import React from 'react';
import { Button } from './ui/Button';
import { MessageCircle } from 'lucide-react';
export function Hero() {
  const scrollToPricing = () => {
    document.getElementById('pricing')?.scrollIntoView({
      behavior: 'smooth'
    });
  };
  return <section className="relative bg-gradient-to-b from-rose-50 to-white pt-12 pb-16 px-4 md:pt-20 md:pb-24 overflow-hidden" data-id="element-46">
      <div className="max-w-4xl mx-auto text-center relative z-10" data-id="element-47">
        {/* Badge */}
        <div className="inline-block bg-rose-100 text-rose-800 px-4 py-1.5 rounded-full text-sm font-semibold mb-6 animate-fade-in-up" data-id="element-48">
          Para mamás latinas en USA 🇺🇸
        </div>

        {/* Headline */}
        <h1 className="text-4xl md:text-5xl lg:text-6xl font-extrabold text-gray-900 leading-tight mb-6 tracking-tight" data-id="element-49">
          Gana desde casa con tu celular:{' '}
          <span className="text-rose-600" data-id="element-50">el sistema para mamás</span> que
          venden PDFs por WhatsApp.
        </h1>

        {/* Subheadline/Lead */}
        <p className="text-lg md:text-xl text-gray-600 mb-8 max-w-2xl mx-auto leading-relaxed" data-id="element-51">
          Sin ser experta, sin computadoras caras y sin descuidar a tus hijos.
          Convierte tu experiencia en ingresos usando lo que ya tienes.
        </p>

        {/* Hero Image */}
        <div className="relative mx-auto mb-10 max-w-lg shadow-2xl rounded-2xl overflow-hidden transform rotate-1 hover:rotate-0 transition-transform duration-500" data-id="element-52">
          <img src="https://cdn.magicpatterns.com/uploads/6pbHZmAQu7qXQ2s3YpUy6C/heylloyd-image-1768355960260.png" alt="Mamá Digital Ebook en iPad" className="w-full h-auto object-cover" data-id="element-53" />
        </div>

        {/* CTA */}
        <div className="flex flex-col items-center gap-4" data-id="element-54">
          <Button onClick={scrollToPricing} className="w-full md:w-auto text-xl px-8 py-5" data-id="element-55">
            ¡Quiero Empezar Hoy!
          </Button>
          <p className="text-sm text-gray-500 flex items-center gap-2" data-id="element-56">
            <MessageCircle className="w-4 h-4 text-emerald-600" data-id="element-57" />
            Descarga inmediata al celular
          </p>
        </div>
      </div>
    </section>;
}